
import { Sale } from "@/models/base";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			blob: null as null | Blob,
			signedBy: "",
			key: 0
		};
	},
	props: {
		sale: {
			type: Object as () => Sale,
			required: true
		},
	},
	computed: {
		saleTypeName(): string {
			return this.sale.getTypeName(this.sale.getLng());
		},
		hasSigned(): boolean {
			return this.blob != null;
		},
		valid(): boolean {
			return this.hasSigned && this.signedBy != "";
		}
	},
	methods: {
		reset() {
			this.blob = null;
			this.key ++;
		},
		confirm() {
			if (!this.hasSigned) return;
			if (!this.signedBy) return;
			if (!this.blob) return;
			this.$emit("save",this.signedBy,this.blob);
		},
		onInput(blob: Blob) {
			this.blob = blob;
		},
		close(){
			this.$emit("close");
		}
	},
	mounted() {
		if (this.sale.Contact && this.sale.Contact.MainAddress) {
			this.signedBy = this.sale.Contact.MainAddress.FullName;
		}
		if (this.sale.DeliveryAddress) {
			this.signedBy = this.sale.DeliveryAddress.FullName;
		}
		if (this.sale.InvoiceAddress) {
			this.signedBy = this.sale.InvoiceAddress.FullName;
		}
	},
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
});
